/**
 * Landing Declaration Cloud API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * Contact: support@indigo.si
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EPrinterCashDrawerStatus = 'Ok' | 'HighState' | 'LowState';

export const EPrinterCashDrawerStatus = {
    Ok: 'Ok' as EPrinterCashDrawerStatus,
    HighState: 'HighState' as EPrinterCashDrawerStatus,
    LowState: 'LowState' as EPrinterCashDrawerStatus
};

